import DashboardSection from "../components/DashboardSection";

function money(value) {
  const amount = Number(value || 0);
  return `$${amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

function PopularProducts({ products }) {
  const rows = products || [];
  return (
    <DashboardSection title="Popular Products" description="Your best-selling products this month.">
      <div className="popular-product-list">
        {rows.length ? rows.map((product, index) => (
          <article className="popular-product" key={product.id || product.name}>
            <span className="popular-product__rank">{index + 1}</span>
            <div className="popular-product__image"><span>{product.name.charAt(0)}</span></div>
            <div className="popular-product__content"><strong>{product.name}</strong><span>{product.category}</span></div>
            <div className="popular-product__numbers"><strong>{product.sold} sold</strong><span>{money(product.revenue)}</span></div>
          </article>
        )) : <p className="admin-dashboard-empty">No completed product sales this month.</p>}
      </div>
    </DashboardSection>
  );
}

export default PopularProducts;
